import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import axios from 'axios';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';
import { serverUrl } from '../../../Constant/Static/config';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

function RegistrationGraph() {
    const [registrationStatData, setRegistrationStatData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [csrfToken, setCsrfToken] = useState('');

    const fetchRegistrationStat = async () => {
        if (csrfToken) {
            try {
                const response = await axios.post(
                    `${serverUrl}/api/admin/stats/registrations`,
                    {},
                    {
                        headers: {
                            'CSRF-Token': csrfToken,
                        },
                        withCredentials: true
                    }
                );
                // // console.log(response);
                if (response.status === 200 && response.data) {
                    setRegistrationStatData(response.data);
                    // // console.log(registrationStatData);
                } else {
                    console.error('Error fetching registration data');
                    setRegistrationStatData([]);
                }
            } catch (error) {
                console.error('Error:', error);
                setRegistrationStatData([]);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true
                });
                setCsrfToken(response.data.csrfToken);
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);

    useEffect(() => {
        if (csrfToken) {
            fetchRegistrationStat();
            const intervalId = setInterval(fetchRegistrationStat, 300000); // 5 minutes

            return () => clearInterval(intervalId);
        }
    }, [csrfToken]);

    const dates = registrationStatData && registrationStatData.length > 0
        ? registrationStatData.map(data => String(data.reg_date || data.date).substring(0, 10)) : [];
    const counts = registrationStatData && registrationStatData.length > 0 ? registrationStatData.map(data => data.count) : [];

    // // console.log('Series of Dates', dates);
    // // console.log('Application Count', counts);

    const chartData = {
        labels: dates,
        datasets: [
            {
                label: 'Registrations',
                data: counts,
                borderColor: '#42A5F5',
                fill: false,
                tension: 0.1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        return `Registrations: ${tooltipItem.raw}`;
                    },
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Date',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'No. of Registrations',
                },
                beginAtZero: true,
            },
        },
    };

    return (
        <div className="chart-sub-container">
            <h4>Total Registrations Date-Wise</h4>
            {loading ? <p>Loading...</p> : (registrationStatData && registrationStatData.length > 0 ? <Line data={chartData} options={options} /> : <p>No data available</p>)}
        </div>
    );
}

export default RegistrationGraph;
